export default "__VITE_ASSET__CqHZXUb0__"